import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import './style.scss';
import './mobile.scss';

const RubricAppearanceIconsBlock = (props) => {
  const
    {rubric} = props,
    {is_mobile} = props.applicationState,
    blocks = rubric.rubric_appearance?.rubric_appearance_icon_blocks;

  if (!blocks || !blocks?.length) {
    return null;
  }

  return (
    <section className='page-content-section'>
      <div className="rubric-appearance-icons-blocks">
        {
          blocks.map(block => {
            return (
              <div
                key={block.id}
                className="rubric-appearance-icons-block"
              >
                <div className="rubric-appearance-icons-block__icon">
                  <img src={block.icon.image} />
                </div>
                <div className="rubric-appearance-icons-block__text">
                  {
                    is_mobile ?
                      <>
                        <div className='rubric-appearance-icons-block__text-top'>{block.mobile_title}</div>
                        <div className='rubric-appearance-icons-block__text-bottom'>{block.mobile_text}</div>
                      </>
                      : block.title
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </section>
  );
}

const
  mapStateToProps = ({applicationState, railsContext}) => {
    return {
      applicationState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    null
  );

export default compose(withConnect)(RubricAppearanceIconsBlock);

